import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import PageLoadingSpinner from "components/common/PageLoader";
import BreadCrumb from "components/common/BreadCrumb";
import { getDocumentTitle } from "utils/helpers";
import { getEnquirySiteVisit } from "../services/EnquirySiteVisitService";
import type { EnquirySiteVisit } from "../types/enquiry-site-visit.types";
import EnquirySiteVisitOverviewContext from "./EnquirySiteVisitOverviewContext";
import Section from "./Section";

const EnquirySiteVisitOverview = () => {
  document.title = getDocumentTitle("Site Visit Details");
  const { id } = useParams();
  const [enquirySiteVisit, setEnquirySiteVisit] = useState<EnquirySiteVisit | null>(
    null,
  );
  const [loading, setLoading] = useState(true);

  const loadEnquirySiteVisitData = useCallback(async () => {
    if (!id) {
      setEnquirySiteVisit(null);
      setLoading(false);
      return;
    }
    const numericId = Number(id);
    setLoading(true);
    try {
      const visitRes = await getEnquirySiteVisit(numericId);

      if (visitRes.success) {
        setEnquirySiteVisit(visitRes.data);
      } else {
        setEnquirySiteVisit(null);
      }
    } catch (err) {
      console.warn(err);
      setEnquirySiteVisit(null);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    void loadEnquirySiteVisitData();
  }, [loadEnquirySiteVisitData]);

  if (loading) return <PageLoadingSpinner message="Loading site visit..." />;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Site Visit Details"
          pageTitle="Enquiry Management"
          items={[
            {
              label: "Site visits",
              path: "/enquiry-management/site-visits",
            },
          ]}
        />
        <EnquirySiteVisitOverviewContext.Provider
          value={{
            enquirySiteVisit,
            refetch: loadEnquirySiteVisitData,
          }}
        >
          <Section />
        </EnquirySiteVisitOverviewContext.Provider>
      </Container>
    </div>
  );
};

export default EnquirySiteVisitOverview;
